import { OrderModel } from './order'
import { AuditStatus } from './status'

export enum RefundStatus {
  CHANGE = 'CHANGE',
  PROCESSING = 'PROCESSING',
  REFUNDCLOSE = 'REFUNDCLOSE',
  SUCCESS = 'SUCCESS',
  TO_BE_REFUND = 'TO_BE_REFUND'
}

export const RefundsOrderBy: {
  [key: string]: string;
} = {
  createdAt: 'CREATED_AT',
  refundNumber: 'REFUND_NUMBER',
  status: 'STATUS',
  totalAmount: 'TOTAL_AMOUNT',
  totalPrice: 'TOTAL_PRICE',
  transactionNumber: 'TRANSACTION_NUMBER',
  updatedAt: 'UPDATED_AT',
  auditStatus: 'AUDIT_STATUS'
}

export interface Refund {
  account: RefundAccount;
  channel: string;
  createdAt: string;
  description: string;
  errCode: string;
  errCodeDes: string;
  id: number;
  indexNumber: number;
  order: OrderModel;
  orderId: number;
  queryTriedTimes: number;
  recvAccount: string;
  refundNumber: number;
  status: RefundStatus;
  successTime: string;
  totalAmount: number;
  totalPrice: number;
  transactionNumber: string;
  type: RefundType;
  auditStatus: AuditStatus;
  updatedAt: string;
}

enum RefundType {
  RETURN_THE_WAY_COME
}

enum RefundAccount {
  REFUND_SOURCE_RECHARGE_FUNDS,
  REFUND_SOURCE_UNSETTLED_FUNDS
}
